(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-heading"] && !Shopify.designMode) return;
  try {
    
  function initializeTruncation() {
    document.querySelectorAll('.collection-description-truncated').forEach((element) => {
      const content = element.querySelector('.collection-description-content');
      const toggle = element.querySelector('.collection-description-toggle');
      const readMoreText = element.querySelector('.read-more-text');
      const readLessText = element.querySelector('.read-less-text');
      const truncateLines = parseInt(element.dataset.truncateLines, 10) || 3;

      if (!content || !toggle) return;

      let isExpanded = false;
      let targetHeightPx = 0;
      let fullHeightPx = 0;

      function checkTruncation() {
        content.classList.remove('truncated');
        content.style.removeProperty('--content-height');
        const lineHeight = parseFloat(getComputedStyle(content).lineHeight) || 1.5;
        const targetHeight = lineHeight * truncateLines;
        fullHeightPx = content.scrollHeight;
        targetHeightPx = targetHeight;

        if (fullHeightPx > targetHeight) {
          content.style.setProperty('--content-height', targetHeightPx + 'px');
          content.classList.add('truncated');
          toggle.style.display = 'inline';
        } else {
          content.style.setProperty('--content-height', fullHeightPx + 'px');
          toggle.style.display = 'none';
        }
      }

      function toggleContent() {
        isExpanded = !isExpanded;

        if (isExpanded) {
          content.classList.remove('truncated');
          content.style.setProperty('--content-height', fullHeightPx + 'px');
        } else {
          content.style.setProperty('--content-height', targetHeightPx + 'px');
          content.classList.add('truncated');
        }

        if (readMoreText && readLessText) {
          readMoreText.style.display = isExpanded ? 'none' : 'inline';
          readLessText.style.display = isExpanded ? 'inline' : 'none';
        }
        toggle.setAttribute('aria-expanded', isExpanded);
      }

      requestAnimationFrame(() => {
        checkTruncation();
        toggle.addEventListener('click', toggleContent);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTruncation);
  } else {
    initializeTruncation();
  }

  document.addEventListener('shopify:section:load', initializeTruncation);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["values-slideshow"] && !Shopify.designMode) return;
  try {
    
  function initValuesSlideshows() {
    if (typeof window.Swiper === 'undefined') return;
    const sections = document.querySelectorAll('.values-slideshow[data-section-id]');
    sections.forEach(function(section) {
      const swiperEl = section.querySelector('.values-slideshow__swiper');
      const progressBar = section.querySelector('.values-slideshow__progress-segments');
      if (!swiperEl) return;

      const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
      
      // Initialize progress bar segments
      if (progressBar && slideCount > 1) {
        progressBar.innerHTML = '';
        for (let i = 0; i < slideCount; i++) {
          const segment = document.createElement('div');
          segment.className = 'values-slideshow__progress-segment';
          if (i === 0) {
            segment.classList.add('active');
          }
          progressBar.appendChild(segment);
        }
      }

      const swiper = new window.Swiper(swiperEl, {
        slidesPerView: 1.2,
        spaceBetween: 20,
        autoHeight: true,
        touchEventsTarget: 'container',
        breakpoints: {
          750: {
            slidesPerView: 1.5,
            spaceBetween: 30,
            autoHeight: false,
          },
        },
        on: {
          slideChange: function() {
            // Update progress bar
            if (progressBar) {
              const segments = progressBar.querySelectorAll('.values-slideshow__progress-segment');
              segments.forEach(function(segment, index) {
                if (index === this.activeIndex) {
                  segment.classList.add('active');
                } else {
                  segment.classList.remove('active');
                }
              }.bind(this));
            }
          },
        },
      });
    });
  }

  function runWhenSwiperReady() {
    if (window.Swiper) {
      initValuesSlideshows();
      return;
    }
    var attempts = 0;
    var maxAttempts = 100;
    var interval = setInterval(function() {
      if (window.Swiper) {
        clearInterval(interval);
        initValuesSlideshows();
      } else if (++attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runWhenSwiperReady);
  } else {
    runWhenSwiperReady();
  }

  } catch(e) { console.error(e); }
})();
})();
